<template>
<div class="search-page">
  <popup
    ref="popup"
    class="full-page"
    fullScreen
    :visible="true">
    <!-- 搜索框 -->
    <div class="search-bar">
      <div class="search-input">
        <rich-input
          v-model="keyword"
          :placeholder="gettext('请输入')"
          clearable
        >
          <i class="richic-search" slot="prepend"></i>
        </rich-input>
      </div>
      <span class="cancel-btn" @click="hide">{{gettext('取消')}}</span>
    </div>
    <!-- 搜索结果 -->
    <div class="search-result" v-show="keyword">
      <rich-loading v-show="loading"></rich-loading>
      <div class="search-scroll-wrap" v-if="!loading">
        <rich-result-page
          type="empty"
          v-show="result.length === 0"
        />
        <rich-scroll ref="searchScroll" v-if="result.length > 0">
          <div class="search-list-inner-wrap">
            <ul class="search-list">
              <li
                class="search-list-item"
                v-for="(item, index) in result"
                :key="index">
                <rich-cell
                  :key="index"
                  :title="item.userName + ' (' + item.name +  ')'"
                  @click="clickSearchItem(item)"
                />
              </li>
              <slot></slot>
            </ul>
          </div>
        </rich-scroll>
      </div>
    </div>
  </popup>
</div>
</template>
<script>
import popup from './Popup'
import { request } from '@/common/utils/request'
import { debounce } from '@/common/utils/util'

export default {
  name: 'UserSugSelect',
  components: {
    popup
  },
  data () {
    return {
      isFirstSearch: true,
      loading: false,
      keyword: '',
      result: [],

      loaded: false,
      activeIndex: -1
    }
  },
  watch: {
    keyword (nVal) {
      if (nVal) {
        this.loading = true
        this.searchHandler(nVal)
      }
    }
  },
  methods: {
    show () {
      this.$refs.popup.show()
    },
    hide () {
      this.$refs.popup.hide()
      setTimeout(() => {
        this.remove()
      }, 200)
    },
    searchHandler: debounce(async function (keyword) {
      request.get({
        url: 'crm.signingMainBasicFunction.getUserSug',
        params: {
          keyWord: keyword
        }
      }).then(res => {
        this.result = res.data || []
      }).finally(() => {
        this.loading = false
      })
    }, 800),
    clickSearchItem (item) {
      this.$emit('select', item)
      this.keyword = ''
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep.popup .popup-panel .popup-choose {
  height: 0px;
}
.search-page {
  overflow: hidden;
  height: 100%;
  position: relative;
  .search-bar {
    position: relative;
    align-items: center;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    padding: 20px 0 20px 20px;
    z-index: 1;
    height: 100px;
    background: #FFF;
    // .rich-input {
    //   width: 100%;
    //   background-color: $color-col-line;
    //   color: $color-light-grey;
    //   &::placeholder {
    //     color: $color-light-grey;
    //   }
    // }
    .cancel-btn {
      padding: 20px;
      font-size: $fontsize-large;
      color: $color-light-grey;
    }
    .search-input {
      // background: $color-col-line;
      // height: 80px;
      // display: flex;
      flex: 1;
      // .richic-search {
      //   display: block;
      //   line-height: 80px;
      //   font-size: 36px;
      //   color: $color-light-grey;
      //   padding: 0 16px;
      // }
    }
  }
  .rich-loading-spinners {
    margin: 30px auto;
  }
  .search-scroll-wrap {
    position: absolute;
    top: 100px;
    bottom: 0;
    width: 100%;
    .search-list-inner-wrap {
      padding-bottom: 60px;
    }
  }
  .search-list {
    padding: 0 20px;
  }
  .search-history {
    position: absolute;
    width: 100%;
    top: 100px;
    bottom: 0;
    z-index: 0;
    font-size: 32px;
    .history-title {
      height: 125px;
      line-height: 125px;
      padding: 0 30px;
      span {
        font-weight: 800;
      }
      i{
        float: right ;
      }
    }
    .search-list-wrap {
      position: absolute;
      top: 125px;
      bottom: 0;
      width: 100%;
      overflow: auto;
      .remove-btn {
        padding: 20px 0 20px 20px;
      }
    }
  }
}
</style>
